module.exports = __webpack_public_path__ + "static/06-un-0385787@2x-4f09a6258b0435e9f75b766edd05bb55.png";